
<div style="padding-left: 20%;padding-right: 20%;">
    <h2 style="font-weight: 700;display: flex;justify-content: center;">NOTIFICATIONS</h2>
    <div>
        <form #myForm="ngForm">
            <div >
                <div class="input-wrapper">
                    <input type="text" placeholder="Search" class="form-control" id="searchtext" #searchInput
                        [(ngModel)]="searchText" (input)="searchNotifications(searchInput.value)" name="searchInput">
                    <span class="clear-icon" (click)="clearSearchInput(searchInput)">&times;</span>
                </div>
                <div class="notification-list">
                    <div *ngFor="let notification of pagedNotifications">
                        <div class="notification-item">
                            <div class="notification-header">
                                <div class="notification-title">{{ notification.title }}</div>

                                <div  class="notification-date">{{ notification.pDate+pacificTimezone(notification.pDate) | date:'medium'}}
                                {{userTimezoneName(notification.pDate)}}</div>
                            </div>
                            <div class="notification-description" [innerHTML]="notification.description"></div>
                            <a *ngIf="notification.link" href="{{ notification.link }}">Click here to know more!</a>
                        </div>
                    </div>
                </div>
                <div class="pagination-container">
                    <mat-paginator [length]="filteredNotifications?.length" [pageSize]="pageSize"
                        [pageSizeOptions]="pageSizeOptions" (page)="onPageChange($event)"></mat-paginator>
                </div>
            </div>
        </form>
    </div>

</div>
